import React, { useState, useContext, useEffect, FC } from 'react';

import { GlobalContext } from '../../../../store';

import { AdminTabsNav, ITabStep } from '../../Common/AdminTabsNav/AdminTabsNav';
import useLocation from '../../../../contrib/Hooks/useLocation.hook';
import { Subheader } from '../../Common/Subheader/Subheader';
import AdminsSection from './AdminsSection/AdminsSection';
import ClubSettingsSection from './ClubSettingsSection/ClubSettingsSection';
import PagesSection from './PagesSection/PagesSection';
import SeasonsSection from './SeasonsSection/SeasonsSection';

interface IProps {
  clubId: number;
}

const ClubSettings: FC<IProps> = props => {
  const { clubId } = props;
  const {
    adminClubs,
    actions: {
      adminClubs: { get: getAdminClubs, getManagement: getClubManagement },
      adminClubCreditCard,
      adminMemberships,
      adminCourses
    }
  } = useContext(GlobalContext);

  const { location } = useLocation();

  const [activeTab, setActiveTab] = useState(0);
  const [direction, setDirection] = useState('');
  const [leaveTab, setLeaveTab] = useState(0);

  useEffect(() => {
    const routeRegex = new RegExp(`section=seasons`, 'mi');

    const matches = location.search.match(routeRegex);

    if (matches) {
      setActiveTab(2);
    }
  }, [location]);

  useEffect(() => {
    adminCourses.all();
    adminClubCreditCard.get(clubId);
    adminMemberships.getMemberships(clubId).catch();
    getAdminClubs(clubId).then(() => {
      getClubManagement(clubId);
    });
  }, [clubId]);

  const setTab = (_: any, newActiveTab: number) => {
    const newLeaveTab = activeTab;

    if (newLeaveTab !== newActiveTab) {
      setActiveTab(newActiveTab);
      setLeaveTab(newLeaveTab);
      setDirection(newLeaveTab < newActiveTab ? 'ltr' : 'rtl');
    }
  };

  const currentClub = adminClubs[clubId];

  const steps: ITabStep[] = [
    {
      content: <ClubSettingsSection />,
      label: 'CLUB SETTINGS'
    },
    {
      content: <PagesSection clubId={clubId} />,
      label: 'POLICIES'
    },
    {
      content: <SeasonsSection />,
      label: 'SEASONS'
    },
    {
      content: <AdminsSection clubId={clubId} />,
      label: 'ADMIN SETTINGS'
    }
  ];

  return (
    <div className="admin-layout">
      {currentClub && (
        <Subheader
          title={steps[activeTab].label}
          clubId={currentClub.id}
          profileImage={currentClub.profileImage}
          editImageEnabled={true}
        />
      )}

      <div className="club-settings-content">
        <AdminTabsNav steps={steps} activeTab={activeTab} setTab={setTab} />

        <div className={`slider ${direction} admin-layout`}>
          {steps.map(({ content }, index) => (
            <div
              key={`club-settings-step-${index}`}
              className={`slide top admin-wrapper club-settings ${
                activeTab === index ? 'active' : ''
              } ${leaveTab === index ? 'leave' : ''}`}
            >
              {content}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClubSettings;
